import I18n from '@js/modules/translations';

import Notification from '@js/components/layouts/notification';

import Geolocation from '@js/modules/maps/geolocation';


const GeolocationMapModule = {
    _geolocationModel: {
        geolocator: undefined,

        geolocateLocation: undefined,
        geoTrackingLocation: undefined,

        geolocationFound: [],

        positionMarker: undefined,

        directionMarker: undefined,
        positionMarkerAngle: 90,
        // animationMarker: undefined,
        // update map view only every 3 minutes

        trackLastUpdate: undefined,

        // Center map on tracking position after X minutes
        recenterMapAfter: 5,

        geoTrackingZoom: 16
    },

    plugGeolocator(options = {}) {
        this._geolocationModel.geolocator = Geolocation.buildGeolocator({
            mapId: options.mapId,
            onGeolocating: this._handleGeolocating,
            track: options.isTracking || false,
            showRotateMap: options.showRotateMap || false,
            maxZoom: this._geolocationModel.geoTrackingZoom
        });
    },

    plugGeolocatorButtons() {
        if (this._geolocationModel.geolocator) {
            Geolocation.buildButtons({
                map: this._model.map
            });
        }
    },

    onGeolocation(successCallback, failedCallback) {
        if (this._geolocationModel.positionMarker) {
            this._geolocationModel.positionMarker.remove();
            this._geolocationModel.positionMarker = undefined;
        }

        Geolocation.geolocate({
                geolocator: this._geolocationModel.geolocator,
                maxZoom: this._geolocationModel.geoTrackingZoom,
                showUserHeading: false,
                track: false
            },
            (mode, locatedCoordinates) => {
                if (mode === 'position' && locatedCoordinates) {
                    this._geolocatedFuncs(mode, locatedCoordinates);

                    this._geolocationModel.geolocateLocation = locatedCoordinates;

                    this.flyTo([locatedCoordinates.longitude, locatedCoordinates.latitude], this._geolocationModel.geoTrackingZoom);

                    if (successCallback) {
                        successCallback(locatedCoordinates);
                    }
                }
            },
            (errorCode) => {
                this._manageFailedGeolocation(errorCode);

                if (failedCallback) {
                    failedCallback();
                }
            });
    },

    onTrackGeolocation(successCallback) {
        // this.trackDeviceOrientation();

        this.closeAllPopups();
        this._mapModel.hasPopup = false;

        Geolocation.geolocate({
                geolocator: this._geolocationModel.geolocator,
                track: true
                // maxZoom: this._geolocationModel.geoTrackingZoom
            },
            (mode, locatedCoordinates) => {
                if (mode === 'tracking' && locatedCoordinates) {
                    if (!this._geolocationModel.geoTrackingLocation) {
                        this._geolocatedFuncs(mode, locatedCoordinates);
                    }

                    this._geolocationModel.geoTrackingLocation = locatedCoordinates;

                    // Set map view every X minutes
                    if (this._geolocationModel.trackLastUpdate) {
                        const positionCoordinates = [locatedCoordinates.longitude, locatedCoordinates.latitude];

                        const currentTime = new Date();
                        const elapsedTimeInMinutes = (currentTime.getTime() - this._geolocationModel.trackLastUpdate.getTime()) / (60 * 1000);

                        const isMarkerInMapView = this._model.map.getBounds()
                            .contains(positionCoordinates);

                        if (this._model.map.isMoving()) {
                            this._geolocationModel.trackLastUpdate = currentTime;
                        } else if (!isMarkerInMapView && elapsedTimeInMinutes > this._geolocationModel.recenterMapAfter) {
                            this.flyTo(positionCoordinates, this._geolocationModel.geoTrackingZoom);
                        }
                    } else {
                        this._geolocationModel.trackLastUpdate = new Date();
                    }

                    // Called on each tracking
                    if (successCallback) {
                        successCallback();
                    }
                }
            }, this._manageFailedGeolocation);
    },

    onStopTrackingGeolocation() {
        Geolocation.stopGeolocating({
            geolocator: this._geolocationModel.geolocator
        });

        this._geolocationModel.geoTrackingLocation = undefined;
        this._geolocationModel.geolocateLocation = undefined;

        if (this._geolocationModel.positionMarker) {
            this._geolocationModel.positionMarker.remove();
            this._geolocationModel.positionMarker = null;
        }
        if (this._geolocationModel.directionMarker) {
            this._geolocationModel.directionMarker.remove();
            this._geolocationModel.directionMarker = null;
        }
    },

    getCurrentLocationPoint() {
        return this._geolocationModel.geoTrackingLocation || this._geolocationModel.geolocateLocation;
    },

    // trackDeviceOrientation() {
    //     Geolocation.deviceOrientation(function (rotation) {
    //         if (this._geolocationModel.trackPositionMarker) {
    //             this._geolocationModel.trackPositionMarker.getElement().innerHTML = '<div id=\'direction-orientation\' class=\'direction-orientation\' style=\'transform: rotate(' + this._geolocationModel.positionMarkerAngle + rotation + 'deg)\'><div class=\'direction-center\'/></div>';
    //         }
    //     }.bind(this));
    // };

    // getMapPosition = function () {
    //     return {
    //         center: this._model.map.getCenter(),
    //         zoom: this._model.map.getZoom()
    //     };
    // },

    /* Private Methods
    ******************** */
    _geolocatedFuncs(mode, positionLocated) {
        for (let i = 0, n = this._geolocationModel.geolocationFound.length; i < n; i++) {
            this._geolocationModel.geolocationFound[i](mode, positionLocated);
        }
    },

    _handleGeolocating() {
        Notification.info(I18n.t('js.maps.geolocation.in_progress'));
    },

    _manageFailedGeolocation(errorCode) {
        if (errorCode === 0) {
            // Unknown error
            Notification.error(I18n.t('js.maps.geolocation.errors.default'));
        }
        if (errorCode === 1) {
            // Access denied by user
            Notification.error(I18n.t('js.maps.geolocation.errors.reject'));
        }
        if (errorCode === 2) {
            // Position unavailable
            Notification.error(I18n.t('js.maps.geolocation.errors.default'));
        }
        if (errorCode === 3) {
            // Timed out
            Notification.error(I18n.t('js.maps.geolocation.errors.default'));
        }
        if (errorCode === 4) {
            // No support
            Notification.error(I18n.t('js.maps.geolocation.errors.no_support'));
        }
    }
};

export default GeolocationMapModule;
